import { render } from "./CreateDureeMedicament.vue?vue&type=template&id=d4fb8aae&scoped=true"
import script from "./CreateDureeMedicament.vue?vue&type=script&lang=js"
export * from "./CreateDureeMedicament.vue?vue&type=script&lang=js"

import "./CreateDureeMedicament.vue?vue&type=style&index=0&id=d4fb8aae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4fb8aae"]])

export default __exports__